'use client';

import { notFound } from 'next/navigation';
import { use } from 'react';

import UserPool from '@flipster/features/src/userpool';
import { UserPoolIdContext } from '@flipster/features/src/userpool/user-pool.state';

interface PageProps {
  params: Promise<{ id: string }>;
}

const NewUserLaunchpoolPage = ({ params }: PageProps) => {
  const { id } = use(params);

  if (!id) {
    notFound();
  }

  return (
    <UserPoolIdContext value={id}>
      <UserPool />
    </UserPoolIdContext>
  );
};

export default NewUserLaunchpoolPage;
